var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.content},[_c('h3',[_vm._v(_vm._s(_vm.data.title)),_c('br'),_vm._v(_vm._s(_vm.data.sub_title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.data.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }